/* ==========================================================================
   DANG — Team Page

   DESKTOP (can hover): names list sits centered with the photo column
   collapsed. Hovering a rider expands the layout to 2/3 names + 1/3 photo and
   fades that rider's photo in. Leaving the list bounces it back.

   PHONES (cannot hover): the hover panel is useless, so tapping a name opens
   that rider's photo inline, directly beneath their name — the photo lands
   between the names instead of at the bottom of the list. One photo open at a
   time. Each photo's `src` is only assigned on first open, so a phone no longer
   downloads 11 rider photos it can never show.

   The mobile test is the same media query the CSS uses — KEEP THEM IN SYNC.
   `hover: none` is the honest test for "cannot hover"; the width clause covers
   narrow desktop windows and makes the behaviour testable by resizing, because
   desktop browsers report hover even at a phone-sized viewport.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var MOBILE_QUERY = '(hover: none), (max-width: 749px)';

  function isMobileMode() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  var teamSection = document.querySelector('[data-dang-team]');
  if (!teamSection) return;

  var grid = teamSection.querySelector('.dang-team__grid');
  var preview = teamSection.querySelector('[data-team-preview]');
  var list = teamSection.querySelector('.dang-team__list');
  var rows = teamSection.querySelectorAll('.dang-team__row[data-rider]');

  /* ---------- desktop: photo panel follows the cursor ---------- */

  if (grid && preview) {
    var imgs = preview.querySelectorAll('.dang-team__preview-img');

    var showRider = function (riderId) {
      grid.classList.add('dang-team__grid--active');
      imgs.forEach(function (img) {
        img.classList.toggle('dang-team__preview-img--active', img.dataset.rider === riderId);
      });
    };

    var reset = function () {
      grid.classList.remove('dang-team__grid--active');
      imgs.forEach(function (img) {
        img.classList.remove('dang-team__preview-img--active');
      });
    };

    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        /* Checked per-event rather than once at load, so resizing across the
           breakpoint switches behaviour without a reload. */
        if (isMobileMode()) return;
        showRider(row.dataset.rider);
      });
    });

    if (list) {
      list.addEventListener('mouseleave', function () {
        if (isMobileMode()) return;
        reset();
      });
    }
  }

  /* ---------- phones: tap a name, photo opens under it ---------- */

  var toggles = teamSection.querySelectorAll('[data-team-toggle]');

  function closeRow(row) {
    row.classList.remove('is-open');
    var button = row.querySelector('[data-team-toggle]');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  toggles.forEach(function (button) {
    button.addEventListener('click', function () {
      if (!isMobileMode()) return;

      var row = button.closest('.dang-team__row');
      if (!row) return;

      var wasOpen = row.classList.contains('is-open');

      // one at a time — opening a rider closes whoever was open
      rows.forEach(function (other) {
        if (other !== row) closeRow(other);
      });

      if (wasOpen) {
        closeRow(row);
        return;
      }

      row.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');

      // fetch the photo the first time this rider is opened, never again
      var img = row.querySelector('[data-src]');
      if (img && img.dataset.loaded !== 'true') {
        img.src = img.dataset.src;
        img.dataset.loaded = 'true';
      }
    });
  });
});
